import { Component } from "react";
import WebServiceConsumer from "../../../../services/WebServiceConsumer";
import RouteUtil from "../../../../utils/RouteUtil";
import { labels } from "../../../../localization/labels";
import { AppContext } from "../../App/AppContext";
import PathUtil from "../../../../utils/PathUtil";
import RequestHandler from "../../../../services/RequestHandler";

import $ from "jquery";
window.$ = $;

class PageComponent extends Component {
  constructor(props) {
    super(props);

    //private variable
    this._serviceConsumer = new WebServiceConsumer();
    this._requestHandler = new RequestHandler(
      props.requestHandler,
      this.prepareCall,
      this.performCalls
    );

    this.messageHandler = props.messageHandler;
    this.breadcrumbsHandler = props.breadcrumbsHandler;

    this.locationKeys = [];
    this.previousKey = undefined;
  }

  pendCreateCall = (call, data) => {
    this._requestHandler.pendCall("create", call, data);
  };

  pendUpdateCall = (call, data) => {
    this._requestHandler.pendCall("update", call, data);
  };

  pendDeleteCall = (call, data) => {
    this._requestHandler.pendCall("delete", call, data);
  };

  performPendingCalls() {
    return this._requestHandler.performPendedCalls();
  }

  prepareCall(call) {
    if (this._serviceConsumer) {
      this._serviceConsumer.push(call);
    }
  }

  performCalls() {
    if (this._serviceConsumer) {
      return this._serviceConsumer.consume(this.focusInput);
    }
  }

  focusInput = () => {
    var afInput = this.context.afInput;
    const afInputExists = afInput && afInput.current;

    if (afInputExists) {
      afInput = afInput.current;
      const inputValue = afInput.value;
      const afInputEmpty =
        inputValue === undefined || inputValue === null || inputValue === "";

      const inptFocused = $(`#${afInput.id}` + "").is(":focus");
      const alreadyFocusedIsDummyEmpty =
        document.activeElement &&
        !document.activeElement.value &&
        document.activeElement.id === "";
      if (
        afInputEmpty &&
        (!document.activeElement ||
          (alreadyFocusedIsDummyEmpty && !inptFocused))
      ) {
        setTimeout(function () {
          afInput.focus();
        }, 0);
      }
    }
  };

  resetComponent() {
    //do nothing here
  }

  resolveItemId() {
    return PathUtil.pathParameter(this.props, "id");
  }

  onDeleteSuccessMessage = message => {
    this.messageHandler.handleSuccess({ text: labels.deleted });
  };

  onSaveSuccessMessage = response => {
    this.messageHandler.handleSuccess({ text: labels.saved });
    if (response) {
      return response.json();
    }
  };

  changePath(path, title, extra = {}, backPosition = -1) {
    extra.title = title;

    if (!extra.hasOwnProperty("from")) {
      extra.from = this.props.history.location.pathname;
    }

    if (backPosition <= 0) {
      this.props.history.push(path, extra);
    } else {
      this.props.history.go(backPosition * -1);
    }

    if (this.messageHandler) {
      this.messageHandler.unhandle();
    }
  }

  componentWillMount() {
    const { history } = this.props;

    if (history !== undefined) {
      this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
      this.handleLocationChange(history);
    }
  }

  componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
  }

  handleLocationChange = location => {
    var path = location.pathname;
    var isBack = this.props.history.action === "POP";
    var isForward = this.props.history.action === "REPLACE";
    var isUpdate = RouteUtil.getLocationParameter(this.props.history, "update");

    if (isForward && path === undefined) {
      path = this.props.history.location.pathname;
    } else if (
      isBack &&
      path === undefined &&
      (!RouteUtil.locationParameterExists(this.props.history, "title") ||
        this.locationKeys.length === 0)
    ) {
      path = this.props.history.location.pathname;
    }

    if (path !== undefined) {
      const title = RouteUtil.getLocationParameter(
        this.props.history,
        "title",
        this.getComponentTitle()
      );

      if (title !== undefined) {
        const from = RouteUtil.getLocationParameter(this.props.history, "from");

        const fromExists = RouteUtil.locationParameterExists(
          this.props.history,
          "from"
        );

        if (location.key !== undefined) {
          if (!this.locationKeys.includes(location.key)) {
            this.locationKeys.push(location.key);
            isForward = true;
          } else if (
            this.locationKeys.indexOf(location.key) <
            this.locationKeys.indexOf(this.previousKey)
          ) {
            isBack = true;
          } else {
            isForward = true;
          }
          this.previousKey = location.key;
        }

        if (this.locationKeys.length === 0) {
          isBack = false;
        }
        isForward = isForward || (!isBack && from !== undefined);

        if (!isBack || isForward) {
          if (isForward && fromExists) {
            this.breadcrumbsHandler.addBreadcrumb(path, title);
          } else {
            if (isUpdate !== undefined && isUpdate === true) {
              this.breadcrumbsHandler.refreshBreadcrumb(path, title);
            } else {
              this.breadcrumbsHandler.resetBreadcrumb(path, title);
            }
          }
        } else {
          this.breadcrumbsHandler.gotoBreadcrumb(path, title);
        }
      }
    }
  };

  setComponentTitle = (title, updateCurrent = false) => {
    if (updateCurrent) {
      const isTitleUpdate =
        RouteUtil.getLocationParameter(this.props, "title") !== title &&
        title !== undefined;

      const shouldUpdateLocation =
        isTitleUpdate ||
        !RouteUtil.locationParameterExists(this.props, "title");

      RouteUtil.changeLocationParameters(
        this.props,
        [
          { parameterName: "title", newValue: title },
          { parameterName: "update", newValue: updateCurrent }
        ],
        shouldUpdateLocation
      );
      RouteUtil.getAndDeleteLocationParameter(this.props, "update", false);
    } else if (!RouteUtil.locationParameterExists(this.props, "title")) {
      RouteUtil.changeLocationParameters(this.props, [
        { parameterName: "title", newValue: title }
      ]);
    }
  };

  getComponentTitle = () => {
    throw new Error("You have to implement the method getComponentTitle!");
  };

  isComponentRefresh = () => {
    const isClickFromSameSideMenuItem =
      this.props.location &&
      this.props.location.pathname ===
        RouteUtil.getLocationParameter(this.props, "from");

    if (isClickFromSameSideMenuItem) {
      //delete it so that every time the componentDidMount is entered this function would not return true
      RouteUtil.getAndDeleteLocationParameter(this.props, "from", false);
    }

    return isClickFromSameSideMenuItem;
  };

  renderProps() {
    return {};
  }

  handlerProps() {
    return {
      breadcrumbsHandler: this.breadcrumbsHandler,
      messageHandler: this.messageHandler
    };
  }
}

PageComponent.contextType = AppContext;

export default PageComponent;
